module.exports = __webpack_public_path__ + "img/25.0b498cff.webp";